import { stringify } from "qs";
import Api from "~/service/Api";

class Immersive3dTourExportRequestRepository {
  update(tourId, data, query) {
    let url = `/immersive-3d-tour/export-requests/${tourId}`;

    url += `?${stringify(query)}`;

    return Api.post(url, data);
  }
}

export default Immersive3dTourExportRequestRepository;
